module.exports = __webpack_public_path__ + "static/media/eastate.2f45f3f1.png";